if (!customElements.get('collection-category-strip')) {
  customElements.define('collection-category-strip', class CollectionCategoryStrip extends HTMLElement {
    constructor() {
      super();

      this.track = this.querySelector('[data-category-track]');
      this.controls = this.querySelector('[data-category-controls]');
      this.previousButton = this.querySelector('[data-category-previous]');
      this.nextButton = this.querySelector('[data-category-next]');
      this.activeLink = this.querySelector('[aria-current="page"]');
      this.updateControls = this.updateControls.bind(this);
    }

    connectedCallback() {
      if (!this.track || !this.controls || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', () => this.scroll(-1));
      this.nextButton.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', this.updateControls, { passive: true });

      this.resizeObserver = new ResizeObserver(this.updateControls);
      this.resizeObserver.observe(this.track);

      requestAnimationFrame(() => {
        this.centerActiveLink();
        this.updateControls();
      });
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.updateControls);
      this.resizeObserver?.disconnect();
    }

    scroll(direction) {
      const distance = Math.max(this.track.clientWidth * 0.72, 260);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: distance * direction,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    centerActiveLink() {
      if (!this.activeLink) return;

      const trackBounds = this.track.getBoundingClientRect();
      const activeBounds = this.activeLink.getBoundingClientRect();
      const centeredPosition = this.track.scrollLeft
        + activeBounds.left
        - trackBounds.left
        - ((trackBounds.width - activeBounds.width) / 2);

      this.track.scrollTo({
        left: Math.max(centeredPosition, 0),
        behavior: 'auto'
      });
    }

    updateControls() {
      const maximumScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      const hasOverflow = maximumScroll > 4;

      this.controls.hidden = !hasOverflow;
      this.previousButton.disabled = !hasOverflow || this.track.scrollLeft <= 4;
      this.nextButton.disabled = !hasOverflow || this.track.scrollLeft >= maximumScroll - 4;
    }
  });
}
